import React from 'react'
import Image from 'next/image'
import { Row, Rows, Column } from '@paper-monster/web/src/components/layout'
import arrowsIconImg from '@paper-monster/web/src/assets/buy-flow/right-side/arrows-icon.png'
import emailAccessDocImg from '@paper-monster/web/src/assets/buy-flow/right-side/email--access-doc.png'
import emailSearchFilesImg from '@paper-monster/web/src/assets/buy-flow/right-side/email--search-files.png'
import emailFileProtectionImg from '@paper-monster/web/src/assets/buy-flow/right-side/email--file-protection.png'
import styles from '@paper-monster/web/src/components/blocks/CheckoutSideEmail.module.scss'

export default function CheckoutSideEmailNeatDocs() {
  return (
    <Column center className={styles.background} gap={32} size={66}>
      <Row className={styles.pinkBox}>
        <Column>
          <Rows className={styles.left} gap={32}>
            <Rows gap={12}>
              <Image alt="" className={styles.neatLogo} src={arrowsIconImg} />
              <h1>Every document. One place. Always ready.</h1>
            </Rows>
            <p>NeatDocs gives you a permanent, organized home for every receipt, bill, invoice and contract.</p>
          </Rows>
        </Column>
        <Column>
          <Rows className={styles.statsRows} gap={32}>
            <Rows className={styles.stats}>
              <div>
                <Image alt="" src={emailAccessDocImg} />
              </div>
              <p>Snap, email or upload: every document is classified automatically</p>
            </Rows>

            <Rows className={styles.stats}>
              <div>
                <Image alt="" src={emailSearchFilesImg} />
              </div>
              <p>Find any document in seconds, from your phone or laptop</p>
            </Rows>

            <Rows className={styles.stats}>
              <div>
                <Image alt="" src={emailFileProtectionImg} />
              </div>
              <p>Bank-level encryption on every file</p>
            </Rows>
          </Rows>
        </Column>
      </Row>
    </Column>
  )
}
